// extracted by mini-css-extract-plugin
export default {"container":"ShopsPage_container__cY45f"};